import Component from 'components/ProductCategories/Select'

export default Component
